<svg *ngIf="festiveService.festival$ | async" viewBox="0 0 48 56" aria-hidden="true" focusable="false">
  <!-- Larger lantern on the longer string -->
  <g class="fl-swing fl-swing--a">
    <line x1="14" y1="0" x2="14" y2="14" stroke="#D4A017" stroke-width="1.2" />
    <rect x="9" y="13" width="10" height="3" rx="1" fill="#8B1E3F" />
    <path d="M14 16 L24 27 L14 38 L4 27 Z" fill="#F59E0B" stroke="#8B1E3F" stroke-width="1.2" />
    <path d="M14 20 L19.5 27 L14 34 L8.5 27 Z" fill="#FFD166" />
    <path d="M4 27 H24" stroke="#8B1E3F" stroke-width="0.8" />
    <g stroke="#E11D74" stroke-width="1.1" stroke-linecap="round">
      <line x1="10" y1="37" x2="10" y2="46" />
      <line x1="14" y1="38" x2="14" y2="49" />
      <line x1="18" y1="37" x2="18" y2="46" />
    </g>
  </g>

  <!-- Smaller lantern, swinging out of step -->
  <g class="fl-swing fl-swing--b">
    <line x1="35" y1="0" x2="35" y2="6" stroke="#D4A017" stroke-width="1.2" />
    <rect x="31.5" y="5.5" width="7" height="2.4" rx="1" fill="#8B1E3F" />
    <path d="M35 8 L42 15 L35 22 L28 15 Z" fill="#E11D74" stroke="#8B1E3F" stroke-width="1" />
    <path d="M35 11 L38.6 15 L35 19 L31.4 15 Z" fill="#FFD166" />
    <g stroke="#F59E0B" stroke-width="1" stroke-linecap="round">
      <line x1="32.5" y1="21" x2="32.5" y2="28" />
      <line x1="35" y1="22" x2="35" y2="30" />
      <line x1="37.5" y1="21" x2="37.5" y2="28" />
    </g>
  </g>
</svg>
